import * as React from 'react';
import { SVGProps } from 'react';

export const QatarFlag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    imageRendering="optimizeQuality"
    fillRule="evenodd"
    clipRule="evenodd"
    viewBox="0 0 512 512"
    {...props}
  >
    <g fillRule="nonzero">
      <path
        fill="#4D4D4D"
        d="M256 0c70.684 0 134.689 28.664 181.012 74.987C483.336 121.311 512 185.316 512 256c0 70.684-28.664 134.689-74.988 181.013C390.689 483.336 326.684 512 256 512c-70.677 0-134.689-28.664-181.013-74.987C28.664 390.689 0 326.676 0 256c0-70.684 28.664-134.689 74.987-181.013C121.311 28.664 185.316 0 256 0z"
      />
      <path
        fill="#fff"
        d="M256.001 19.597c65.278 0 124.382 26.466 167.162 69.242 42.776 42.78 69.242 101.884 69.242 167.162S465.939 380.384 423.16 423.16c-42.777 42.78-101.881 69.246-167.159 69.246-65.278 0-124.382-26.466-167.162-69.243-42.777-42.779-69.243-101.884-69.243-167.162S46.062 131.619 88.839 88.839c42.78-42.776 101.884-69.242 167.162-69.242z"
      />
      <path
        fill="#8A1538"
        d="M256.001 39.594c119.517 0 216.407 96.887 216.407 216.407 0 119.518-96.89 216.407-216.407 216.407-119.521 0-216.407-96.889-216.407-216.407 0-119.52 96.886-216.407 216.407-216.407z"
      />
      <path
        fill="#fff"
        d="M198.715 47.276l57.723 15.747-88.387 24.113 88.387 24.113-88.387 24.113 88.387 24.113-88.387 24.113 88.387 24.113-88.387 24.113 88.387 24.116-88.387 24.113 88.387 24.114-88.387 24.113 88.387 24.113-88.387 24.113 88.387 24.113-88.387 24.113 88.387 24.113-57.989 15.821C106.871 439.451 39.594 355.589 39.594 256.001c0-99.685 67.407-183.611 159.121-208.725z"
      />
    </g>
  </svg>
);
